import UseSWR from "swr";
import { API } from "../conflict";

const fetcher = (url) => API.get(url).then((res) => {
  if (res.data.data) {
    return res.data.data
  }

});
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,

    },
  }).then((res) => res.data.data.rows);
const getData = () => {
  const requisitionCheckout = (requisition_id) => {
    const { data, error, mutate } = UseSWR(
      requisition_id?`store/requisition/approved/${requisition_id}`:null,
      fetcher
    );
    console.log(data);
    return {
      data
    }
  }
  const CountData = () => {
    const {
      data,
      error,
      mutate,
    } = UseSWR(`store/warehouse`, fetcher);

    return {
      data, error, mutate
    }
  }
  const requisitionApprovedAdmin = (requisition_id) => {
    const { data, error, mutate } = UseSWR(
      requisition_id?`store/requisition/pending/${requisition_id}`:null,
      fetcher
    );
// console.log(data);
    return {
      data
    }
  }
  const requisitionUserNotification = () => {
 
    const {
      data,
      error,
      mutate,
    } = UseSWR(`store/requisition/byId?page=0&limit=10000`, fetcher1);

    return {
      data, mutate, error
    }
  }


  return { requisitionCheckout, CountData, requisitionApprovedAdmin, requisitionUserNotification }
}


export default getData